var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55155 13.4055C2.27955 13.0325 2.14355 12.8455 2.04955 12.4855C1.98609 12.165 1.98609 11.8351 2.04955 11.5145C2.14355 11.1535 2.27955 10.9665 2.55155 10.5945C4.04055 8.54951 7.30455 4.99951 12.0015 4.99951C16.6985 4.99951 19.9625 8.54951 21.4515 10.5935C21.7235 10.9665 21.8595 11.1535 21.9535 11.5135C22.017 11.8341 22.017 12.164 21.9535 12.4845C21.8595 12.8455 21.7235 13.0325 21.4515 13.4045C19.9625 15.4495 16.6985 18.9995 12.0015 18.9995C7.30455 18.9995 4.04055 15.4495 2.55155 13.4055Z",
    stroke: "#84878A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3L3 21",
    stroke: "#84878A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eyeClose.a0efbcd6f444cb1da4d481a0818cf462.svg";
export { ForwardRef as ReactComponent };